import { Component, Host, h, Listen, Element, Prop } from '@stencil/core';
import { Components } from '../../../../components';
import { isIe } from '../../../common/_helpers/browsers';
import {
	calculateChildTagName,
	getChildComponent,
	getChildComponents,
} from '../_helpers/prefixes';
// CSP comment start
// This will be out commented when we fix our bug
// import {
// 	moveInlineStylesToHead,
// 	removeInlineStylesFromHead,
// } from '../_helpers/content-security-policy';
// CSP comment end

@Component({
	tag: 'ds-body-tabs',
})
export class BodyTabs {
	@Element() el: HTMLDsBodyTabsElement;

	// Comma separated list of block level component names as specified in Teamsite/Orca
	@Prop() nestedComponents = '';

	@Listen('tabSelected')
	tabSelectedHandler(event: CustomEvent) {
		const bodyTabsTagName = this.el.tagName.toLowerCase();
		if (
			(
				event.target as HTMLDsTabGroupElement
			).parentElement.tagName.toLowerCase() === bodyTabsTagName
		) {
			const globalWindow = window.parent || window;
			globalWindow.location.hash = encodeURIComponent(
				(event.detail.tab.legend
					? event.detail.tab.legend
					: event.detail.tab.label
				).replace(/ /g, '-')
			);
		}
	}

	@Listen('tabTransitionComplete')
	tabTransitionCompleteHandler(event: CustomEvent) {
		const chartTagName = calculateChildTagName(this.el, 'ds-chart');

		Array.from(event.detail.tab.querySelectorAll(chartTagName)).forEach(
			(chart: Components.DsChart) => chart.updateChartWidth()
		);
	}

	tabGroup: HTMLDsTabGroupElement;
	tabs: HTMLDsTabElement[];

	componentWillLoad(): void {
		this.indexAllPageComponents();

		this.tabGroup = getChildComponent(this.el, 'ds-tab-group');
		const tabTag = calculateChildTagName(this.el, 'ds-tab');

		this.tabs = Array.from(this.tabGroup.children).filter(
			(el) => el.tagName.toLowerCase() === tabTag
		) as HTMLDsTabElement[];

		if (!this.tabGroup) {
			console.error(
				'The ds-body-tabs component must contain a nested ds-tab-group component.'
			);
		}
		if (!this.tabs.length) {
			console.error(
				'The ds-body-tabs component must contain at least one nested ds-tab component.'
			);
		}
	}

	componentDidLoad(): void {
		/*
		 * window.parent.location.hash is used
		 * because in dev environment we are working in iframe(storybook use it) and window.location.hash will
		 * point to iframe's location hash not to main window one. If there is no iframe,
		 * window.parent.location is equal to window.location.
		 */
		const globalWindow = window.parent || window;
		if (globalWindow.location.hash) {
			this.selectTabByLabel(globalWindow.location.hash.replace('#', ''));
		}
		if (this.tabGroup && isIe()) {
			this.tabGroup.animateTabs = false;
			this.tabs.forEach((tab) => {
				const nestedTabGroups = getChildComponents<HTMLDsTabGroupElement>(
					tab,
					'ds-tab-group'
				);
				nestedTabGroups.forEach((tabGroup) => (tabGroup.animateTabs = false));
			});
		}
		// CSP comment start
		// This will be out commented when we fix our bug
		// moveInlineStylesToHead(this.el.id);
		// CSP comment end
	}

	// CSP comment start
	// This will be out commented when we fix our bug
	// componentDidUpdate() {
	// 	moveInlineStylesToHead(this.el.id);
	// }

	// disconnectedCallback() {
	// 	removeInlineStylesFromHead(this.el.id);
	// }
	// CSP comment end

	selectTabByLabel(hashValue: string): void {
		this.tabs.forEach((item, i) => {
			if (
				encodeURIComponent(
					(item.legend ? item.legend : item.label).replace(/ /g, '-')
				) === hashValue
			) {
				this.tabGroup.selectTab(i);
			}
		});
	}

	indexAllPageComponents(): void {
		this.nestedComponents.split(',').forEach((componentName) => {
			const matchedComponents = document.querySelectorAll(
				`[data-componentname="${componentName.trim()}"]`
			);
			for (let i = 0; i < matchedComponents.length; i++) {
				matchedComponents[i].setAttribute(
					'data-component-index',
					(i + 1).toString()
				);
			}
		});
	}

	render() {
		return <Host></Host>;
	}
}
